;(function() {
/* @ngInject */
function UctovnikObjednaneController(CompletedOrderService, $window, $filter, Helpers){
    let vm = this;
    let server = CompletedOrderService;

    vm.payment = "movement";
    vm.showMovement = false;
    vm.downloadLabel = $filter("translate")('payments.documents.general');

    server.getCompletedOrderData().then(onPaymentInfoLoad);
    server.getUserData().then(onUserDataLoad);

    function onPaymentInfoLoad(payment) {
        if(payment) {
            vm.orderId = payment.orderId;
            vm.price = payment.price;
            vm.paymentData = payment;
            vm.invoiceHref = `/invoice/download?orderId=${payment.orderId}`;
            vm.proformaHref = `/invoice/download?proforma=true&orderId=${payment.orderId}`;

        } else {
            $window.location = "/";
        }
    }
    function onUserDataLoad(user) {
        var d = Helpers.getDataLayer(vm.orderId, 'uctovnici',
            'ine', '', user);

        var dataLayer = $window.dataLayer = $window.dataLayer || [];
        if (d)
            dataLayer.push(d);
    }
}

angular.module("firmaren")
    .controller("UctovnikObjednaneController", UctovnikObjednaneController);
}());
